<template>

  <ModalContainer queryParam="propuesta020" ref="modalContainer" size="xl">

    <b-alert 
      v-if="messageAlert" 
      show 
      :variant="messageAlert.variant"
      class="p-2 text-center"
    >
      {{ messageAlert.text }}
    </b-alert>

    <b-card>

      <div class="mb-1" v-if="dataProceso">
        <div>
          <b>Procedimiento:</b> {{ dataProceso.codigo }} - {{ dataProceso.descripcion }}
        </div> 

        <div>
          <b>Paciente: </b> {{ dataProceso.paciente }} 
        </div>
      </div>
      
      <h6 class="text-center text-primary mt-3 my-2">CONSTANTES VITALES / BALANCE HIDRICO</h6>

      <b-tabs>

        <b-tab title="CONSTANTES VITALES">
          <b-row>

            <b-col>

              <b-row>

                <b-col class="mb-1" cols="6">
                  <span>Fecha :</span>
                  <flat-pickr
                    size="sm"
                    class="form-control form-control-sm"
                    v-model="fechaActual"
                    locale="es"
                    :config="birthDateConfig"
                  />
                </b-col>

                <b-col class="mb-1" cols="6">
                  <b-form-radio
                    v-model="dataConstantes.selectedDay"
                    :value="null"
                  >N/A</b-form-radio>
                  
                  <b-form-radio
                    v-model="dataConstantes.selectedDay"
                    value="1"
                  >DIA DE INTERNACION</b-form-radio>

                  <b-form-radio
                    v-model="dataConstantes.selectedDay"
                    value="2"
                  >DIA DE POST QUIRURGICO</b-form-radio>
                </b-col>

                <hr class="col-12">
              </b-row>

              <div>

                <div class="row mb-1">
                  <span class="col-2">Hora :</span>
                  <b-timepicker
                    class="col-3"
                    v-model="horaActual"
                    locale="es"
                    format="HH:mm"
                    size="sm"
                  />
                </div>

                <div class="row mb-1">
                  <span class="col-4">Pulso :</span>
                  <b-form-input
                    class="col-3"
                    type="number"
                    placeholder="Ingrese el pulso"
                    size="sm"
                    v-model="constantes.pulso"
                  />
                </div>

                <div class="row mb-1">
                  <span class="col-4">Temperatura :</span>
                  <b-form-input
                    class="col-3"
                    type="number"
                    placeholder="Ingrese la temperatura"
                    size="sm"
                    v-model="constantes.temperatura"
                  />
                </div>

                <div class="row mb-1">
                  <span class="col-4">Frecuencia Respiratoria :</span>
                  <b-form-input
                    class="col-4"
                    type="number"
                    placeholder="Ingrese la frecuencia respiratoria"
                    size="sm"
                    v-model="constantes.frespiratoria"
                  />
                </div>

                <div class="row mb-1">
                  <span class="col-4">Presion Sistolica :</span>
                  <b-form-input
                    type="number"
                    placeholder="Ingrese la presion sistolica"
                    size="sm"
                    v-model="constantes.sistolica"
                    class="col-4"
                  />
                </div>

                <div class="row mb-1">
                  <span class="col-4">Pulsioximetria :</span>
                  <b-form-input
                    class="col-4"
                    type="number"
                    placeholder="Ingrese la pulsioximetria"
                    size="sm"
                    v-model="constantes.pulsioximetria"
                  />
                </div>

                <div class="row mb-1">
                  <span class="col-4">Presion Diastolica :</span>
                  <b-form-input
                    class="col-4"
                    type="number"
                    placeholder="Ingrese la presion diastolica"
                    size="sm"
                    v-model="constantes.diastolica"
                  />
                </div>

                
                <div class="row mb-1">
                  <span class="col-4">Responsable :</span>
                  <b-form-input
                    class="col-8"
                    type="text"
                    placeholder="Nombre del responsable"
                    size="sm"
                    v-model="constantes.responsable"
                  />
                </div>

                <div class="col-12 d-flex justify-content-end">
                  <b-button
                    class="mt-1"
                    variant="info"
                    size="sm"
                    @click="agregarEvo"
                  >
                    Agregar +
                  </b-button>
                </div>

              </div>
            </b-col>

   
            <ChartConstantes
              class="col mx-1"
              :tableConstantes.sync="dataConstantes.tableConstantes"
            />

          </b-row>

          <b-table
            class="mt-2"
            v-if="dataConstantes && dataConstantes.tableConstantes.length"
            bordered
            striped
            responsive
            small
            :items="dataConstantes.tableConstantes"
            :fields="fields"
          >
            <template #cell(acciones)="data">
              <b-button
                @click="eliminarRegistro(data.index)"
                variant="danger"
                size="sm"
              >
                <i class="fa-solid fa-trash"></i>
              </b-button>
            </template>
          </b-table>
        </b-tab>


        <b-tab title="BALANCE HIDRICO/RECOMENDACIONES">
          <b-row>
            <b-col>
              <div class="text-center mb-1"><b>Ingesta - Eliminación </b></div>
              <b-card>
                <div><span class="text-primary">Ingresos Ml:</span></div>
                <b-row>
                  <b-col cols="6">
                    <label>Enteral: </label>
                    <b-form-input v-model="constantes.bhidrico.ienteral" size="sm"></b-form-input>
                  </b-col>
                  <b-col cols="6">
                    <label>Parenteral: </label>
                    <b-form-input v-model="constantes.bhidrico.iparenteral" size="sm"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <label>Via Oral: </label>
                    <b-form-input v-model="constantes.bhidrico.iviaoral" size="sm"></b-form-input>
                  </b-col>
                  <b-col cols="6">
                    <label> <strong> Total Ingreso ML: </strong></label>
                    <b-form-input v-model="constantes.bhidrico.totalingresos" size="sm"></b-form-input>
                  </b-col>
                </b-row>
              </b-card>
              <b-card>
                <div><span class="text-warning">Eliminaciones Ml:</span></div>
                <b-row>
                  <b-col cols="4">
                    <label>Orina: </label>
                    <b-form-input v-model="constantes.bhidrico.eorina" size="sm"></b-form-input>
                  </b-col>
                  <b-col cols="4">
                    <label>Drenaje: </label>
                    <b-form-input v-model="constantes.bhidrico.edrenaje" size="sm"></b-form-input>
                  </b-col>
                  <b-col cols="4">
                    <label>Vomito: </label>
                    <b-form-input v-model="constantes.bhidrico.evomito" size="sm"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <label>Diarreas: </label>
                    <b-form-input v-model="constantes.bhidrico.ediarreas" size="sm"></b-form-input>
                  </b-col>
                  <b-col cols="4">
                    <label>Otros (especifique): </label>
                    <b-form-input v-model="constantes.bhidrico.eotros" size="sm"></b-form-input>
                  </b-col>
                  <b-col cols="4">
                    <label> <strong> Balance hidrico total: </strong></label>
                    <b-form-input size="sm" v-model="constantes.bhidrico.bhtotal"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <label>Dieta prescrita: </label>
                    <b-form-input v-model="constantes.bhidrico.dieta" size="sm"></b-form-input>
                  </b-col>
                  <b-col cols="4">
                    <label>Numero de comidas: </label>
                    <b-form-input v-model="constantes.bhidrico.numcomidas" size="sm"></b-form-input>
                  </b-col>
                  <b-col cols="4">
                    <label>Numero de micciones: </label>
                    <b-form-input v-model="constantes.bhidrico.nummicciones" size="sm"></b-form-input>
                  </b-col>
                  <b-col cols="4">
                    <label>Numero de deposiciones: </label>
                    <b-form-input v-model="constantes.bhidrico.numdeposiciones" size="sm"></b-form-input>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
            <b-col>
              <div class="text-center mb-1">
                <label><b>Cuidados Generales</b></label>
              </div>
              <b-card>
                <b-row>
                  <b-col cols="2">
                    <label><b>Aseo:</b></label>
                    <b-form-checkbox v-model="constantes.cgenerales.aseo" switch size="sm"></b-form-checkbox>
                  </b-col>
                  <b-col cols="2">
                    <label><b>Baño:</b></label>
                    <b-form-checkbox v-model="constantes.cgenerales.bano" switch size="sm"></b-form-checkbox>
                  </b-col>
                  <b-col>
                    <label><b>Posicion (especifique):</b></label>
                    <b-form-textarea v-model="constantes.cgenerales.posicion" size="sm"></b-form-textarea>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <label><b>Reposo (especifique):</b></label>
                    <b-form-textarea v-model="constantes.cgenerales.reposo" size="sm"></b-form-textarea>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <label><b>Otros (especifique):</b></label>
                    <b-form-textarea v-model="constantes.cgenerales.otros" size="sm"></b-form-textarea>
                  </b-col>
                </b-row>
              </b-card>
              <div style="margin-top: -20px" class="text-center">
                <label><b>Colocacion de dispositivos medicos</b></label>
              </div>
              <b-card>
                <b-row>
                  <b-col cols="2">
                    <label><b>Via central:</b></label>
                    <b-form-checkbox v-model="constantes.dispositivos.viacentral" switch size="sm"></b-form-checkbox>
                  </b-col>
                  <b-col cols="2">
                    <label><b>Via periferica:</b></label>
                    <b-form-checkbox v-model="constantes.dispositivos.viaperiferica" switch size="sm"></b-form-checkbox>
                  </b-col>
                  <b-col cols="2">
                    <label><b>Sonda nasogastrica:</b></label>
                    <b-form-checkbox v-model="constantes.dispositivos.sgastrica" switch size="sm"></b-form-checkbox>
                  </b-col>
                  <b-col cols="2">
                    <label><b>Sonda vesical:</b></label>
                    <b-form-checkbox v-model="constantes.dispositivos.svesical" switch size="sm"></b-form-checkbox>
                  </b-col>
                  <b-col cols="2">
                    <label><b>Otros:</b></label>
                    <b-form-checkbox  v-model="constantes.dispositivos.otros" switch size="sm"></b-form-checkbox>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-input
                    v-model="constantes.dispositivos.responsable"
                      placeholder="Ingrese el responsable"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>


      </b-tabs>
    </b-card>
  </ModalContainer>
  
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { doctoresService, auxiliarService } from "@/shared/services";
import { ModalContainer } from "@/shared/components";
import ChartConstantes from "./ChartConstantes.vue";
import { getDataForms } from "../../helpers/getDataForms";

export default {
  components: {
    flatPickr,
    ChartConstantes,
    ModalContainer
  },

  props: {
    tableEvo: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {

      messageAlert: null,
      dataProceso: null,

      constantes: {
        pulso: null,
        temperatura: null,
        frespiratoria: null,
        sistolica: null,
        diastolica: null,
        pulsioximetria: null,
        hora: null,
        responsable: null,
        bhidrico: {
          ienteral: null,
          iparenteral: null,
          iviaoral: null,
          totalingresos: null,
          eorina: null,
          edrenaje: null,
          evomito: null,
          ediarreas: null,
          eotros: null,
          bhtotal: null,
          dieta: null,
          numcomidas: null,
          nummicciones: null,
          numdeposiciones: null,
        },
        cgenerales: {
          aseo: false,
          bano: false,
          posicion: null,
          reposo: null,
          otros: null,
        },
        dispositivos: {
          viacentral: null,
          viaperiferica: null,
          sgastrica: null,
          svesical: null,
          otros: null,
          responsable: null,
        },
      },

      pulso: null,
      temperatura: null,
      dataConstantes: {
        selectedDay: null,
        tableConstantes: [],
      },
      idProcActual: null,
      doctoresService,
      auxiliarService,
      notasEvolucion: null,
      farmacoterapia: null,
      doctor: null,
      auxiliar: null,
      dispositivo: null,
      profesional: null,
      fechaActual: null,
      horaActual: null,
      birthDateConfig: {
        allowInput: true,
        dateFormat: "Y-m-d", // Solo fecha
      },
      procedimiento: [],
      itemsTabla: [],
      fields: [
        {
          key: "fecha",
          label: "Fecha",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        { key: "hora", label: "Hora", sortable: true, thClass: "text-center" },
        {
          key: "pulso",
          label: "Pulso",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "temperatura",
          label: "Temperatura",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "frespiratoria",
          label: "Frec. Resp.",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "presion",
          label: "Presion",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "pulsioximetria",
          label: "Pulsioximetria",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "responsable",
          label: "Responsable",
          sortable: true,
          thClass: "text-center",
        },

        {
          key: "acciones",
          label: "",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
      ],
    };
  },

  created() {
    this.loadData();
    this.setFechaHora();
  },

  methods: {

    async loadData(){
      this.tokenProceso = this.$route.query.f020;
      const dataResponse = await getDataForms(this.tokenProceso, '020');

      if(!dataResponse) return;

      const { dataProceso, dataForm, idRegistroForm, messageAlert } = dataResponse;

      this.messageAlert = messageAlert;

      if(dataProceso)    this.dataProceso = dataProceso;
      // if(dataForm)       this.dataForm   = dataForm;
      if(idRegistroForm) this.idRegistroForm = idRegistroForm;

    },

    setFechaHora(){
      const now        = new Date();
      const year       = now.getFullYear();
      const month      = String(now.getMonth() + 1).padStart(2, "0");
      const day        = String(now.getDate()).padStart(2, "0");
      this.fechaActual = `${year}-${month}-${day}`;
      this.horaActual  = now.getHours() + ":" + ("0" + now.getMinutes()).slice(-2);
    },

    eliminarRegistro(index) {
      this.dataConstantes.tableConstantes.splice(index, 1);
    },
    
    formatTime(time) {
      if (!time) return ""; // Si no hay fecha, retorna una cadena vacía
      const pieces = time.split(":");
      const timeFormatted = pieces[0] + ":" + pieces[1];
      return `${timeFormatted}`;
    },

    agregarEvo() {
      if (
        !this.fechaActual 
        || !this.horaActual 
        || !this.constantes.diastolica 
        || !this.constantes.sistolica 
        || !this.constantes.pulsioximetria 
        || !this.constantes.pulso 
        || !this.constantes.frespiratoria 
        || !this.constantes.temperatura 
        || !this.constantes.responsable
      ) {
        this.$swal.fire({
          icon: "info",
          text: "Por favor, ingrese los datos requeridos.",
        });
        return;
      }
      this.dataConstantes.tableConstantes.push({
        fecha: this.fechaActual,
        hora: this.formatTime(this.horaActual),
        pulso: this.constantes.pulso,
        temperatura: this.constantes.temperatura,
        pulsioximetria: this.constantes.pulsioximetria,
        presion: `${this.constantes.sistolica} / ${this.constantes.diastolica}`,
        frespiratoria: this.constantes.frespiratoria,
        responsable: this.constantes.responsable,
      });
    },

    
  },

  watch: {

    constantes: {
      deep: true,
      handler(newValue) {
        console.log('constantes', newValue);
      },
    },


    // itemsTabla: {
    //   deep: true,
    //   handler(newValue) {
    //     const itemsTabla = JSON.stringify(newValue);
    //     const idProc = this.idProcActual;

    //     localStorage.setItem("tablaEvoluciones", itemsTabla);
    //   },
    // },
  },
};
</script>


